export const getQuerystring = object => {
  const querystring = Object.keys(object).map(function(key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');

  return querystring;
}